Vue.component("TkReader", {
    props: {
        audio: Object
    },
    template: `
        <div class="TkReader" :class="{'TkReader--playing': playing, 'TkReader--disabled': !hasAudio}" @click="playAudio">
            <audio>
                <source :src="player">
            </audio>
        </div>
    `,
    data () {
        return {
            playing: false,
            player: {},
            imgDirectory: config.BACKGROUND_IMAGE_DIRECTORY || ''
        }
    },
    mounted () {
        if (this.hasAudio) {
            this.player = new Audio(this.audioSrc);
            window.addEventListener('audio-playing', (event) => {
                this.stopAudio();
            }, false);
        }
    },
    methods: {
        playAudio () {
            if (!this.player.paused) {
                this.stopAudio();
            } else { 
                this.startAudio();
            }
        },
        startAudio() {
            if(!this.player.src.includes(this.audio.src)) {
                this.player = new Audio(this.audioSrc);
            }
            this.player.currentTime = 0;
            window.dispatchEvent(new CustomEvent('audio-playing'));
            this.player.play()
            this.handleIcon();
        },
        stopAudio() {
            this.player.pause();
            this.handleIcon();
        },
        handleIcon() {
            this.playing = !this.player.paused
        },
        updateAudioClip() {
            
        }
    },
    destroyed() {
        if (this.hasAudio) {
            this.stopAudio();
            window.removeEventListener('audio-playing', (event) => {
                this.stopAudio();
            }, false);
        }
    },
    computed: {
        hasAudio() {
            let x = false;

            if(this.audio !== null && this.audio !== undefined)
                if (this.audio.src !== '')
                    x = true;


            return x;
        },
        audioSrc() {
            return this.imgDirectory + this.audio.src
        }
    }
})